import { ref } from "vue";

type Value = string | number | boolean | undefined | null;

type FormValues = Record<
    string,
    {
        initial: Value;
        current: Value;
    }
>;

/**
 * This hook is used to monitor a form for changes and
 * allow you to tell when something is different from when the form was initialised
 * @param initialValues
 * @returns
 */
export function useDetectFormChanges() {
    const formValues = ref<FormValues>({});

    function initialiseValues(initialValues: Record<string, Value>) {
        Object.keys(initialValues).forEach(key => {
            formValues.value[key] = { initial: initialValues[key], current: initialValues[key] };
        });
    }

    function updateFormValues(values: Record<string, Value>) {
        // Remove keys that are not in the values parameter
        Object.keys(formValues.value).forEach(key => {
            if (!(key in values)) {
                delete formValues.value[key];
            }
        });

        Object.keys(values).forEach(key => {
            if (formValues.value[key]) {
                formValues.value[key].current = values[key];
            } else {
                formValues.value[key] = { initial: values[key], current: values[key] };
            }
        });
    }

    function resetInitialValues() {
        Object.keys(formValues.value).forEach(key => {
            formValues.value[key].initial = formValues.value[key].current;
        });
    }

    function checkFormHasChanges() {
        return Object.keys(formValues.value).some(key => {
            return formValues.value[key].initial !== formValues.value[key].current;
        });
    }
    return { updateFormValues, checkFormHasChanges, resetInitialValues, initialiseValues, formValues };
}
